import React from 'react';
import { IconButton, Tooltip, Zoom, Typography } from '@mui/material';
import { ChevronLeft as LeftArrow, ChevronRight as RightArrow } from '@mui/icons-material';
import moment from 'moment';

export const Panning = (props) => {
  let { direction } = props;
  let directionString = direction == 'right' ? 'Forward' : 'Back';

  let panning = getFuturePanning(direction, props);
  let panPeriodString = moment.duration(panning).humanize();

  return (
    <Tooltip
      disableInteractive
      TransitionComponent={Zoom}
      title={
        <React.Fragment>
          <Typography color="inherit">
            {directionString} {panPeriodString}
          </Typography>
        </React.Fragment>
      }
    >
      <div>
        <IconButton
          size="large"
          color="primary"
          onClick={() => {
            onClick(direction, props);
          }}
          disabled={
            direction == 'right'
              ? moment(props.dateTimeTo).add(panning, 'minutes').isAfter(moment(props.maxDateTo)) ||
                panning == 0
              : false
          }
          data-qa={direction == 'right' ? 'qa-pan-right' : 'qa-pan-left'}
        >
          {direction == 'right' ? <RightArrow fontSize="large" /> : <LeftArrow fontSize="large" />}
        </IconButton>
      </div>
    </Tooltip>
  );
};

function onClick(direction, props) {
  let newPanning = getPanning(props.dateTimeFrom, props.dateTimeTo, props.panningStep);
  let newDateRange = handlePanning(direction, newPanning, props);
  props.onClick(newDateRange);
}

function getFuturePanning(direction, props) {
  let initialPan = getPanning(props.dateTimeFrom, props.dateTimeTo, props.panningStep);

  //show future panning that will be actually applied if the times have rounding configuration
  if (direction == 'left') {
    let newRange = handlePanning('left', initialPan, props);
    let selectedTimeDiff = moment(props.dateTimeFrom).diff(moment(newRange.dateFrom), 'minutes');
    let panning = moment.duration(selectedTimeDiff, 'minutes');
    return panning;
  } else {
    let newRange = handlePanning('right', initialPan, props);
    let selectedTimeDiff = moment(newRange.dateTo).diff(moment(props.dateTimeTo), 'minutes');
    let panning = moment.duration(selectedTimeDiff, 'minutes');
    return panning;
  }
}

function getPanning(dateTimeFrom, dateTimeTo, panningStep) {
  let selectedTimeDiff = moment(dateTimeTo).diff(moment(dateTimeFrom), 'minutes');
  let panning = moment.duration((selectedTimeDiff * panningStep) / 100, 'minutes');
  return panning;
}

function handlePanning(direction, panning, props) {
  let panningMinutes = panning.asMinutes();

  if (direction === 'left') {
    let dateFrom, dateTo;

    if (props.config.Slider) {
      let endType = props.config.Slider.mode.endType;
      if (endType == 'month') {
        //add 2 days to compensate for february
        let panningAdjusted = moment.duration(panning, 'minutes').add(2880, 'minutes');
        let df, dt;

        if (panningAdjusted.asMinutes() < moment.duration(30, 'days').asMinutes()) {
          df = moment(props.dateTimeFrom).startOf('month');
          dt = moment(props.dateTimeTo).startOf('month');
        } else {
          df = normalizeEndOfMonth(props.dateTimeFrom);
          dt = normalizeEndOfMonth(props.dateTimeTo);
        }

        dateFrom = moment(df).subtract(panningAdjusted, 'minutes').toDate();
        dateTo = moment(dt).subtract(panningAdjusted, 'minutes').toDate();
      } else {
        dateFrom = moment(props.dateTimeFrom).subtract(panningMinutes, 'minutes').toDate();
        dateTo = moment(props.dateTimeTo).subtract(panningMinutes, 'minutes').toDate();
      }
    } else {
      dateFrom = moment.utc(props.dateTimeFrom).subtract(panningMinutes, 'minutes');
      dateTo = moment.utc(props.dateTimeTo).subtract(panningMinutes, 'minutes');
    }

    return props.roundDateTime(props, dateFrom, dateTo);
  } else if (direction === 'right') {
    let newDateFrom, newDateTo;

    if (props.config.Slider) {
      let endType = props.config.Slider.mode.endType;
      if (endType == 'date') {
        newDateFrom = moment(props.dateTimeFrom).endOf('day').add(panningMinutes, 'minutes');
        newDateTo = moment(props.dateTimeTo).endOf('day').add(panningMinutes, 'minutes');
      } else if (endType == 'month') {
        //subtract 2 days to compensate for february
        let panningAdjusted = moment.duration(panning, 'minutes').subtract(2880, 'minutes');

        let df = normalizeEndOfMonth(props.dateTimeFrom);
        let dt = normalizeEndOfMonth(props.dateTimeTo);

        newDateFrom = moment.utc(df).add(panningAdjusted, 'minutes');
        newDateTo = moment.utc(dt).add(panningAdjusted, 'minutes');
      }
    } else {
      newDateFrom = moment.utc(props.dateTimeFrom).add(panningMinutes, 'minutes');
      newDateTo = moment.utc(props.dateTimeTo).add(panningMinutes, 'minutes');
    }

    if (!newDateTo.isAfter(props.maxDateTo)) {
      return props.roundDateTime(props, newDateFrom, newDateTo);
    } else {
      let futureDateTo = moment.utc(props.dateTimeTo).add(panningMinutes, 'minutes');
      let spill = moment.duration(futureDateTo.diff(props.maxDateTo, 'minutes'), 'minutes');

      if (props.config.Slider) {
        let endType = props.config.Slider.mode.endType;
        if (endType == 'month') {
          newDateFrom.startOf('month').subtract(spill, 'minutes');
        }
      } else {
        newDateFrom.subtract(spill, 'minutes');
      }

      return props.roundDateTime(props, newDateFrom, moment.utc(props.maxDateTo));
    }
  }
}

function normalizeEndOfMonth(dateTime) {
  let dateTimeWithStartOfMonth = moment(dateTime).startOf('month'); //make sure it is set to the start of the month
  let dateTimeDate = new Date(dateTimeWithStartOfMonth);
  let newDateTime = dateTimeDate.setDate(dateTimeDate.getDate() + 30);

  return newDateTime;
}
